(() => {
  class ColorSwatchesSlider extends HTMLElement {
    constructor() {
      super();

      this.init();
    }

    async init() {
      this.swiperImport = await import(flu.chunks.swiper);
      const { Swiper, Navigation } = this.swiperImport;
      const swiperEl = this.querySelector(".swiper");
      new Swiper(swiperEl, {
        modules: [Navigation],
        slidesPerView: "auto",
        spaceBetween: 8,
        cssMode: true,
        navigation: {
          nextEl: this.querySelector(".swiper-button-next"),
          prevEl: this.querySelector(".swiper-button-prev"),
        },
        breakpoints: {
          960: {
            spaceBetween: 12,
          },
        },
      });

      window.addEventListener("sibling-changed", () => {
        swiperEl.querySelector(".swiper-wrapper").scrollLeft = 0;
      });
    }
  }

  if (!customElements.get("color-swatches-slider")) {
    customElements.define("color-swatches-slider", ColorSwatchesSlider);
  }
})();
